import Vue from 'vue';
// Компоненты
import VTooltip from 'v-tooltip';
import vSelect from 'vue-select';
import VueTextareaAutosize from 'vue-textarea-autosize';
import VueSocketIO from 'vue-socket.io';
import { abilitiesPlugin } from '@casl/vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import ability from './ability';
// Setup
import authGuardSetup from '@/guards/auth.guard';
// Core
import App from './App.vue';
import router from './router';
import store from './store';
import './class-component-hooks';
import './filters';
//
Vue.config.productionTip = false;
// Plugins
Vue.use(VTooltip);
Vue.use(VueTextareaAutosize);
Vue.use(abilitiesPlugin, ability);
// Ручная глобальная регистрация компонентов
Vue.component('VueSlider', VueSlider);
Vue.component('v-select', vSelect);
//#region Автоматическая глобальная регистрация компонентов(из папки shared)
const requireComponent = require.context(
  // Относительный путь до каталога компонентов
  './components/shared',
  // Обрабатывать или нет подкаталоги
  true,
  // Регулярное выражение для определения файлов базовых компонентов
  /[A-Z]\w+\.(vue|js)$/,
);
requireComponent.keys().forEach((fileName) => {
  // Получение конфигурации компонента
  const componentConfig = requireComponent(fileName);

  // Удаление из начала `./` и расширения из имени файла
  const componentName = fileName.replace(/^.+\/(.*)\.\w+$/, '$1');

  // Глобальная регистрация компонента
  Vue.component(
    componentName,
    // Поиск опций компонента в `.default`, который будет существовать,
    // если компонент экспортирован с помощью `export default`,
    // иначе будет использован корневой уровень модуля.
    componentConfig.default || componentConfig,
  );
});
//#endregion
// Получаем всех пользователей во vuex
store.dispatch('fetchUsers');
//#region SocketIO
if (process.env.NODE_ENV !== 'single') {
  Vue.use(
    new VueSocketIO({
      debug: process.env.NODE_ENV === 'development',
      connection: process.env.VUE_APP_WS,
      // vuex: {
      //   store,
      //   actionPrefix: 'SOCKET_',
      //   mutationPrefix: 'SOCKET_',
      // },
    }),
  );
} else {
  Vue.prototype.$socket = { emit: () => 0 };
}
//#endregion
// Auth Guard
authGuardSetup(router);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
